import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Tile from '../tile';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

<template>
  <LinkTo @route="authenticated.admin.pslf.forms">
    <Tile @headerText={{t "pslf.default_approval"}} @showAdminBadge={{true}}>
      <:description>
        {{t "pslf.dashboard.widgets.approval"}}
      </:description>
      <:image>
        {{svgJar
          "online-test"
          width="100%"
          height="100%"
          role="img"
          desc=(t "svg.decision_making")
          class="lg:max-h-56 xl:max-h-full"
        }}
      </:image>
    </Tile>
  </LinkTo>
</template>
